import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type V = {
  '@id': string;
  '@type': 'Symptom';
  id: string;
  name: string;
  slug: string | null;
  description: string | null;
  category: {
    '@id': string;
    '@type': 'SymptomCategory';
    name: string;
  } | null;
};

export function useReadCollection(options?: ReadConfig) {
  return useApiRead<HydraCollection<V>>(`/symptoms`, options);
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/symptoms/${id}`, options);
}
